import DetailInlineSection from './DetailInlineSection';

export default DetailInlineSection;
